import React, { Component, createRef } from 'react';
import Header from '../components/Header';
import ChairmanMessage from '../components/ChairmanMessage';
import FinancialMetrics from '../components/FinancialMetrics';
import AIStrategy from '../components/AIStrategy';
import Awards from '../components/Awards';
import Footer from '../components/Footer';
import DesktopMenu from '../components/DesktopMenu';

class HomeScreen extends Component {
  chairmanRef = createRef();

  scrollToChairman = () => {
    if (this.chairmanRef.current) {
      this.chairmanRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  render() {
    return (
      <div>

        <Header onScrollDown={this.scrollToChairman} />
        <div ref={this.chairmanRef}>
          <ChairmanMessage />
        </div>
        <FinancialMetrics />
        <AIStrategy />
        <Awards />
        <Footer />
      </div>
    );
  }
}

export default HomeScreen;
